import devicesMana from './devicesMana'
import activeTime from './activeTime'
import config from './config'

const zhCN = {
  devicesMana: devicesMana.zhCN,
  devicesManaActiveTime: activeTime.zhCN,
  devicesManaConfig: config.zhCN
}
const enUS = {
  devicesMana: devicesMana.enUS,
  devicesManaActiveTime: activeTime.enUS,
  devicesManaConfig: config.enUS
}
export default { zhCN, enUS }